import { AlertCircle } from "lucide-react";
import { cn } from "@/lib/utils";

interface ErrorAlertProps {
  message: string;
  className?: string;
}

export function ErrorAlert({ message, className }: ErrorAlertProps) {
  return (
    <div
      className={cn(
        "flex items-start gap-2 rounded-md border border-destructive/30 bg-destructive/8 px-3 py-2",
        className,
      )}
    >
      <AlertCircle className="mt-0.5 size-3.5 shrink-0 text-destructive" />
      <p className="text-xs text-destructive">{message}</p>
    </div>
  );
}
